module.exports = __webpack_public_path__ + "img/v1-analyst-mobile.51802cea.png";